// ---------------------------------------------------------------------------
// Shared loading skeleton component
// ---------------------------------------------------------------------------

interface LoadingStateProps {
  /** Number of skeleton rows to display. Defaults to 3. */
  rows?: number;
}

export function LoadingState({ rows = 3 }: LoadingStateProps) {
  return (
    <div className="p-6" role="status" aria-label="Loading content">
      <div className="animate-pulse h-8 bg-surface-sunken rounded-sm w-48 mb-6" />
      <div className="space-y-3">
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className="h-12 bg-surface-sunken/60 rounded-sm" />
        ))}
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );
}
